"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("./extends-fa579b0f.js"),
  n = require("react"),
  t = require("classnames"),
  a = require("prop-types"),
  r = require("./taggedTemplateLiteral-97b463ad.js"),
  i = require("styled-components"),
  o = require("polished/lib/helpers/rem");
function d(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var l,
  s,
  m,
  u,
  c = d(n),
  g = d(t),
  f = d(a),
  h = d(i),
  p = d(o),
  b = h["default"].div(l || (l = r._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var n = e.branding,
      t = e.hasChildren,
      a = e.theme,
      o = "darkTheme" === e.themeType ? a.colors.neutral.white : a.colors.blue.blue,
      d = "pcg" === n ? a.colors.brand.pcg.gold1 : a.colors.gold.gold;
    return i.css(s || (s = r._taggedTemplateLiteral(["\n      @keyframes animate-spin {\n        from {\n          transform: rotate(0deg);\n        }\n        to {\n          transform: rotate(-360deg);\n        }\n      }\n      display: block;\n      position: relative;\n      width: 100%;\n      height: 0;\n      ", "\n      padding-bottom: 100%;\n\n      &::before,\n      &::after {\n        content: '';\n        display: inline-block;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        border: ", " solid transparent;\n        animation-name: animate-spin;\n        animation-duration: 1250ms;\n        animation-timing-function: cubic-bezier(0.12, 0.33, 0.89, 0.68);\n        animation-iteration-count: infinite;\n        border-radius: ", ";\n        /* mobile only, but could just be a weird vw issue */\n        border-width: ", ";\n      }\n\n      &::before {\n          border-bottom-color: ", ";\n          border-left-color: ", ";\n          height: 100%;\n          width: 100%;\n          margin: -50% 0 0 -50%;\n      }\n\n      &::after {\n        border-top-color: ", ";\n        border-right-color: ", ";\n        animation-direction: reverse;\n        /* may need to be adjusted IF the container for the loader is LARGE */\n        height: 90%;\n        width: 90%;\n        margin: -45% 0 0 -45%;\n      }\n    "])), t && {
      "margin-bottom": p["default"](20)
    }, p["default"](3), p["default"](1e3), p["default"](3), o, o, d, d);
  }),
  y = h["default"].div(m || (m = r._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var n = e.loadingSpinnerWidth,
      t = e.theme;
    return i.css(u || (u = r._taggedTemplateLiteral(["\n    width: ", ";\n    max-width: ", ";\n    margin-left: ", ";\n    text-align: center;\n    color: ", ";\n  "])), p["default"](n), p["default"](n), "calc(50% - ".concat(p["default"](n / 2), ")"), t.colors.neutral.grayDark10);
  }),
  T = function T(n) {
    var t = n.branding,
      a = n.children,
      r = n.className,
      i = n.loadingSpinnerWidth,
      o = n.themeType;
    return c["default"].createElement(y, {
      className: g["default"]("loading-container", r),
      loadingSpinnerWidth: i
    }, c["default"].createElement(b, e._extends({
      branding: t,
      className: "loader"
    }, a && {
      hasChildren: !0
    }, {
      themeType: o
    })), a);
  };
T.propTypes = {
  branding: f["default"].oneOf(["nm", "pcg"]),
  children: f["default"].any,
  className: f["default"].string,
  loadingSpinnerWidth: f["default"].number,
  themeType: f["default"].oneOf(["lightTheme", "darkTheme"])
}, T.defaultProps = {
  branding: "nm",
  loadingSpinnerWidth: 140,
  themeType: "lightTheme"
}, exports.LoadingComponent = T;